<template>
    <section class="skin">
        <h2>美肌復仇cp</h2>
        <div class="skin__logo1">
            <img
                src="@/assets/images/theSkin__title01.png"
                class="rwdimg"
                alt="美肌復仇cp"
                loading="lazy"
                data-aos="fade-right"
            />
        </div>
        <div class="skin__logo2">
            <img
                src="@/assets/images/theSkin__title02.png"
                class="rwdimg"
                alt="2%水楊酸精華液＆水楊酸身體乳"
                loading="lazy"
                data-aos="fade-left"
            />
        </div>
        <ul class="skin__category" data-aos="fade-up" data-aos-duration="1500">
            <li v-for="(category, idx) in skinList" :key="category" :class="{ active: idx === skinType }"
                @click="clickSkinType(idx)">
                {{ category.name }}
            </li>
        </ul>
        <KeepAlive>
            <component :is="skinDataShow.component"></component>
        </KeepAlive>
    </section>
</template>

<script setup>
import { ref, computed } from 'vue';
import NeutralSkin from '@/components/widget/NeutralSkin.vue';
import DrySkin from '@/components/widget/DrySkin.vue';
import OilySkin from '@/components/widget/OilySkin.vue';
import CombinationSkin from '@/components/widget/CombinationSkin.vue';

const skinList = [
    {
        name: '中性肌',
        component: NeutralSkin
    },
    {
        name: '乾性肌',
        component: DrySkin
    },
    {
        name: '油性肌',
        component: OilySkin
    },
    {
        name: '混合肌',
        component: CombinationSkin
    }
];
const skinType = ref(0);
let skinDataShow = computed(()=> skinList[skinType.value]);
const clickSkinType = index => skinType.value = index;

</script>

<style lang="scss" scoped>
@import '@/styles/theSkin';
@import '@/styles/swiperOption';
</style>
